import { GetDealRequestContent, GetDealResponseContent } from "@equaliq/api-model";
import { createApiRequest } from "../common";

/**
 * API function to retrieve a deal by ID
 * @param request Deal retrieval parameters
 * @returns Promise with deal details
 */
export const getDealApi = async (request: GetDealRequestContent): Promise<GetDealResponseContent> => {
  const apiRequest = createApiRequest<GetDealResponseContent>('post', '/deals/get');
  return apiRequest(request);
};
